import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Button,
  TextField,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Checkbox,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import { format } from 'date-fns';
import { getTableData, InsertUpdate } from "./Api/Api";
import { ConfirmDialog } from '../../ReusablePopup/CustomModel';

const ReceiptStepper2 = ({ TableData, tableData, setTableData, formData1, setFormData, ResidentId, IsButtonSubmit, AllButtonDisabledOuter,
  handleCancel, fetchReceiptData, setRecId, RecId, handleStepClick, emailSender }) => {
  const navigate = useNavigate();
  const [formData, setformData] = useState({
    RcdAmt: 0,
    AgstBill: 0,
    Amount: 0,
    PytAdvAmount: 0,
    BalAmt: 0,
    Remark: '',
  })
  const [AllTextDisabled, setAllTextDisabled] = useState(true);
  const [AllButtonDisabled, setAllButtonDisabled] = useState(true);
  const [AddDisabled, setAddDisabled] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [confirmDialogVisible, setConfirmDialogVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  // const [tableData, setTableData] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [editedRow, setEditedRow] = useState(null);
  const currentDate = new Date().toISOString().split("T")[0];
  const [originalFetchedData, setOriginalFetchedData] = useState([]);
  const [totalSelectedBalAmt, setTotalSelectedBalAmt] = useState(0);
  const [totalSelectedRcdAmt, setTotalSelectedRcdAmt] = useState(0);

  const columns = [
    { id: "RecFlag", label: "RecType", minWidth: 50, },
    { id: "PytAdvNo", label: "PytAdvNo", minWidth: 50 },
    { id: "BookNo", label: "BookNo", minWidth: 50 },
    { id: "PytAdvDt", label: "PytAdvDt", minWidth: 50 },
    { id: "PytAdvAmount", label: "PytAdvAmt", minWidth: 50 },
    { id: "Amount", label: "RecdAmt", minWidth: 50 },
    { id: "BalAmt", label: "BalAmt", minWidth: 50 },
    { id: "DBFLAG", label: "Flag", minWidth: 50 },
    { id: "Remark", label: "Remark", minWidth: 50 }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newBalAmt = formData.BalAmt;
    if (name === "Amount" || name === "PytAdvAmount") {
      const updatedFormData = {
        ...formData,
        [name]: value,
      };
      if (updatedFormData.PytAdvAmount && updatedFormData.Amount) {
        newBalAmt = updatedFormData.PytAdvAmount - updatedFormData.Amount;
      }
      setformData({
        ...updatedFormData,
        BalAmt: newBalAmt,
      });
    } else {
      setformData({
        ...formData,
        [name]: value,
      });
    }
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      const readFileAsBase64 = (file) => {
        return new Promise((resolve, reject) => {
          reader.onloadend = () => {
            resolve(reader.result);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      };
      readFileAsBase64(file)
        .then((base64String) => {
          setSelectedImage(base64String);
        })
        .catch((err) => {
          toast.error("Error reading file. Please try again.");
        });
    }
  };

  const fetchData = async (ResidentId) => {
    try {
      const payload = {
        RecId: 0,
        Flag: "",
        ResidentId: ResidentId,
        PropId: formData1.PropId
      };

      const response = await getTableData(payload);

      if (response?.data?.Data && response.data.Data.length > 0) {
        const filteredFetchedData = response.data.Data.filter(
          (row) => !tableData.some((existingRow) => existingRow.PytAdvNo === row.PytAdvNo && (existingRow.DBFLAG === 'I' || existingRow.DBFLAG === 'R'))
        )
          .map((row) => {
            const recFlagMap = {
              D: 'Deposit',
              T: 'TopUp',
              R: 'Rent',
              O: 'Other',
            };

            return {
              ...row,
              RecFlagOriginal: row.RecFlag,  // preserve original flag
              RecFlag: recFlagMap[row.RecFlag] || null,  // for display
            };
          });

        setFetchedData(filteredFetchedData);
        setOriginalFetchedData(filteredFetchedData); 
      } else {
        setFetchedData([]);
        setOriginalFetchedData([]);
      }
    } catch (error) {
      setFetchedData([]);
      setOriginalFetchedData([]);
    }
  };

  const handleAddClick2 = () => {
    if (ResidentId) {
      fetchData(ResidentId);
      setOpenDialog(true);
    } else {
      toast.error("No ResidentId provided");
    }
  };

  const handleCheckboxChange = (event, row) => {
    let updatedSelectedRows = [...selectedRows];

    if (event.target.checked) {
      updatedSelectedRows.push(row);
    } else {
      updatedSelectedRows = updatedSelectedRows.filter(selectedRow => selectedRow !== row);
    }

    setSelectedRows(updatedSelectedRows);
    const totalBalAmt = updatedSelectedRows.reduce((total, row) => total + parseFloat(row.BalAmt || 0), 0);
    const totalRcdAmt = updatedSelectedRows.reduce((total, row) => total + parseFloat(row.Amount || 0), 0);

    setTotalSelectedBalAmt(totalBalAmt);
    setTotalSelectedRcdAmt(totalRcdAmt);
  };


  useEffect(() => {
    if (formData1?.TrnRctVchrList && formData1.TrnRctVchrList.length > 0) {
      if (tableData.length === 0) {
        setTableData(formData1.TrnRctVchrList);
      }
    }
  }, [formData1]);

  useEffect(() => {

    const allData = [
      ...(formData1?.TrnRctVchrList || []).filter(row => row.DBFLAG !== 'D'),
      ...tableData.filter(row => row.DBFLAG !== 'D' && !formData1?.TrnRctVchrList?.some(existingRow => existingRow.PytAdvNo === row.PytAdvNo))
    ];

    const totalAmount = allData.reduce((total, row) => {
      return total + parseFloat(row.Amount || 0);
    }, 0).toFixed(2);

    setFormData({
      ...formData1,
      AgstBill: totalAmount,
      RcdAmt: parseFloat(formData1.RcdAmt || 0) === 0 ? totalAmount : formData1.RcdAmt
    });
  }, [tableData, formData1.TrnRctVchrList]);

  const handleConfirmSelection = () => {
    if (selectedRows.length === 0) {
      toast.error("Please select a record.");
      return;
    }

    const newTableData = [...tableData];

    selectedRows.forEach((row) => {
      if (!newTableData.some((existingRow) => existingRow.PytAdvNo === row.PytAdvNo)) {

        const newRow = {
          ...row,
          Amount: row.BalAmt,
          DBFLAG: 'I'
        };
        newTableData.push(newRow);
      } else {
        toast.warning(`PytAdvNo ${row.PytAdvNo} is already added.`);
      }
    });

    setTableData(newTableData);
    setOpenDialog(false);
    setSelectedRows([]);

    const updatedFetchedData = fetchedData.filter(
      (row) => !selectedRows.some((selectedRow) => selectedRow.PytAdvNo === row.PytAdvNo)
    );
    setFetchedData(updatedFetchedData);

    if (!formData1.RcdAmt || formData1.RcdAmt === 0) {
      const totalAmount = calculateTotalAmount();

      setFormData({
        ...formData1,
        RcdAmt: totalAmount,
        AgstBill: totalAmount,
      });
    }
  };

  const calculateTotalAmount = () => {
    const uniqueRows = [];
    const processedPytAdvNos = new Set();

    if (formData1?.TrnRctVchrList && formData1.TrnRctVchrList.length > 0) {
      formData1.TrnRctVchrList.forEach(row => {
        if (!processedPytAdvNos.has(row.PytAdvNo) && row.DBFLAG !== 'D') {
          uniqueRows.push(row);
          processedPytAdvNos.add(row.PytAdvNo);
        }
      });
    }

    tableData.forEach(row => {
      if (!processedPytAdvNos.has(row.PytAdvNo) && row.DBFLAG !== 'D') {
        uniqueRows.push(row);
        processedPytAdvNos.add(row.PytAdvNo);
      }
    });

    return uniqueRows.reduce((total, row) => {
      return total + parseFloat(row.Amount || 0);
    }, 0).toFixed(2);
  };

  const combinedData = (() => {
    const uniqueRows = [];
    const processedPytAdvNos = new Set();

    if (formData1?.TrnRctVchrList && formData1.TrnRctVchrList.length > 0) {
      formData1.TrnRctVchrList.forEach((row) => {
        if (!processedPytAdvNos.has(row.PytAdvNo) && row.DBFLAG !== 'D') {
          uniqueRows.push(row);
          processedPytAdvNos.add(row.PytAdvNo);
        }
      });
    }

    tableData.forEach((row) => {
      if (!processedPytAdvNos.has(row.PytAdvNo) && row.DBFLAG !== 'D') {
        uniqueRows.push(row);
        processedPytAdvNos.add(row.PytAdvNo);
      }
    });

    return uniqueRows;
  })();


  const handleSubmit = async () => {
    try {
      const totalAmount = calculateTotalAmount();
      const enteredRcdAmt = parseFloat(formData1.RcdAmt);

      if (enteredRcdAmt < totalAmount) {
        toast.error("Received amount is less than the Total bill amount.");
        localStorage.setItem('focusRcdAmt', 'true');
        return;
      }
      if (enteredRcdAmt === 0) {
        toast.error("Received amount cannot be zero.");
        localStorage.setItem('focusRcdAmt', 'true');
        return;
      }

      const allCurrentRecords = [
        ...(formData1?.TrnRctVchrList || []),
        ...tableData
      ].filter((value, index, self) =>
        index === self.findIndex((t) => t.PytAdvNo === value.PytAdvNo)
      );

      // const formatDate = (date) => {
      //   if (!date) return null;
      //   const d = new Date(date);
      //   return d.toISOString().split('T')[0];
      // };

      const formatDate = (date) => {
        if (!date) return null;
        try {
          return format(new Date(date), 'yyyy-MM-dd');
        } catch (err) {
          toast.error("Invalid date:", date);
          return null;
        }
      };

      const userId = sessionStorage.getItem('UserId');

      formData1.RecDt = formatDate(formData1.RecDt || currentDate);
      formData1.ChqDt = formatDate(formData1.ChqDt || currentDate);
      formData1.AgstBill = formData1.AgstBill || 0;
      formData1.OnacAmt = formData1.OnacAmt || 0;
      formData1.OnacBal = formData1.OnacBal || 0;
      formData1.RcdAmt = formData1.RcdAmt || 0;
      // formData1.PropId = formData1.PropId || 1;

      const setDefaultId = (id) => (id === 0 || id === null ? 1 : id);

      formData1.AccLedId = setDefaultId(formData1.AccLedId);
      formData1.ResidentId = setDefaultId(formData1.ResidentId);

      if (formData1.TrnRctVchrdtlList && Array.isArray(formData1.TrnRctVchrdtlList)) {
        formData1.TrnRctVchrdtlList = formData1.TrnRctVchrdtlList.map((item) => ({
          ...item,
          RecdtlId: setDefaultId(item.RecdtlId),
          RecId: setDefaultId(item.RecId),
          PytAdvDtlId: setDefaultId(item.PytAdvDtlId),
          PytAdvId: item.PytAdvId || 0,
          RecDt: formatDate(item.RecDt || formData1.RecDt),
        }));
      }

      if (formData1.RecId && formData1.RecId > 0) {
        formData1.DBFLAG = "U";
        formData1.RecNo = formData1.RecNo || '';
      } else {
        formData1.DBFLAG = "I";
        formData1.RecNo = "";
      }

      formData1.Status = formData1.Status || "1";
      const payload = {
        DBFLAG: formData1.DBFLAG,
        RecId,
        RecNo: formData1.RecNo || '',
        RecDt: formData1.RecDt,
        ResidentId: formData1.ResidentId,
        RecFlag: formData1.RecFlag,
        AccLedId: formData1.AccLedId,
        RctVchrRef: formData1.RctVchrRef,
        RcdAmt: formData1.RcdAmt,
        RecdAmt: formData1.RecdAmt,
        AgstBill: formData1.AgstBill || 0,
        OnacAmt: formData1.OnacAmt || 0,
        OnacBal: formData1.OnacBal || 0,
        Pyttype: formData1.Pyttype,
        PytMode: formData1.PytMode,
        TrjId: formData1.TrjId,
        ChequeNo: formData1.ChequeNo,
        ChqInfvr: formData1.ChqInfvr,
        ChqDt: formData1.ChqDt,
        ClgDt: formData1.ClgDt,
        BankName: formData1.BankName,
        CardNo: formData1.CardNo,
        AccountNo: formData1.AccountNo,
        IFSC: formData1.IFSC,
        Status: formData1.Status || "1",
        [formData1.DBFLAG === "I" ? "CreatedBy" : "UpdatedBy"]: userId,
        Remark: formData1.Remark,
        // CreatedBy: formData1.CreatedBy,
        PytAdvId: formData1.PytAdvId || 0,
        PropId: formData1.PropId || 1,
        TrnRctVchrdtlList: allCurrentRecords.map((row) => ({
          DBFLAG: row.DBFLAG || "U",
          RecdtlId: row.RecdtlId || 1,
          BillId: row.BillId || 1,
          PytAdvDtlId: row.PytAdvDtlId || 1,
          BookId: row.BookId || 1,
          Amount: row.Amount || 0,
          PytAdvAmount: row.PytAdvAmount || 0,
          DiscAmt: row.DiscAmt || 0,
          BalAmt: row.BalAmt || 0,
          NetAmt: row.NetAmt || row.Amount,
          Remark: row.Remark || "",
          PytAdvId: row.PytAdvId || 0,
          RecDt: row.RecDt || formData1.RecDt,
          RecFlag: row.RecFlagOriginal || '',
          PropId: formData1.PropId || 1,
          // [formData1.DBFLAG === "I" ? "CreatedBy" : "UpdatedBy"]: userId,
        })),
      };

      let FormattedObj = JSON.stringify(payload).replace(/"/g, '\\"');
      FormattedObj = '"' + FormattedObj + '"';
      const response = await InsertUpdate(FormattedObj);
      if (response?.data?.Status === 0) {
        if (formData1.DBFLAG === "I") {
          toast.success("Data inserted successfully");
          const Id = parseInt(response.data.Data.TrnRctVchrList);
          setRecId(Id);

          fetchReceiptData(RecId, "L");
          //  handleStepClick(0)
          setConfirmDialogVisible(true);
        } else {
          toast.success(response.data.Message);
        }
        fetchReceiptData(RecId, "R");
        setAllButtonDisabled(false);

        setConfirmDialogVisible(true);
      } else {
        toast.error("Error submitting data.");
      }
    } catch (error) {
      toast.error("An error occurred during submission.");
      if (error.response) {
        toast.error("Request failed: " + (error.response.data?.message || "Unknown error"));
      } else {
        toast.error("Network error: " + error.message);
      }
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };
  const formatValue = (value, columnId) => {
    if (columnId.toLowerCase().includes("dt") && (value instanceof Date || !isNaN(Date.parse(value)))) {
      return formatDate(value);
    }
    if (typeof value === "string") return value || "N/A";
    if (typeof value === "number") return value === 0 ? "0.00" : value.toFixed(2);
    return value || "";
  };
  const handleRowClick = (row) => {
    setEditedRow(row);
    setformData({
      Amount: row.Amount,
      BalAmt: row.BalAmt,
      PytAdvAmount: row.PytAdvAmount,
      Remark: row.Remark,
    });
    setAllButtonDisabled(false);
  };
  const handleConfirmEdit = () => {
    if (editedRow) {
      const formRcdAmt = parseFloat(formData1.RcdAmt);
      const formAmount = parseFloat(formData.Amount || 0);

      if (isNaN(formRcdAmt) || isNaN(formAmount)) {
        toast.error("Invalid amount values.");
        return;
      }
      const tolerance = 0.01;

      const amount = parseFloat(formData.Amount || 0);
      const balanceAmount = parseFloat(formData.PytAdvAmount || 0);

      if (isNaN(amount) || isNaN(balanceAmount)) {
        toast.error("Invalid Amount or Balance Amount.");
        return;
      }
      if (amount > balanceAmount) {
        toast.error("Amount cannot be greater than Balance Amount.");
        return;
      }
      
      const isFromTrnRctVchrList = formData1?.TrnRctVchrList?.some(
        row => row.PytAdvNo === editedRow.PytAdvNo
      );

      if (isFromTrnRctVchrList) {
        const updatedTrnRctVchrList = formData1.TrnRctVchrList.map(row => {
          if (row.PytAdvNo === editedRow.PytAdvNo) {
            return {
              ...row,
              PytAdvAmount: formData.PytAdvAmount,
              Amount: formData.Amount,
              BalAmt: formData.BalAmt,
              Remark: formData.Remark,
              DBFLAG: 'U'
            };
          }
          return row;
        });
        setFormData({
          ...formData1,
          TrnRctVchrList: updatedTrnRctVchrList
        });
      }
      const updatedTableData = tableData.map(row => {
        if (row.PytAdvNo === editedRow.PytAdvNo) {
          return {
            ...row,
            PytAdvAmount: formData.PytAdvAmount,
            Amount: formData.Amount,
            BalAmt: formData.BalAmt,
            Remark: formData.Remark,
            DBFLAG: row.DBFLAG === 'I' ? 'I' : 'U'
          };
        }
        return row;
      });

      setTableData(updatedTableData);

      setEditedRow(null);
      setformData({
        Amount: '',
        RcdAmt: '',
        PytAdvAmount: '',
        BalAmt: '',
        Remark: '',
      });
      setAllTextDisabled(true);
      setAllButtonDisabled(true);
    }
  };

  const handleCancelEdit = () => {
    setEditedRow(null);
    setformData({
      Amount: '',
      PytAdvAmount: '',
      RcdAmt: '',
      PytAdvAmount: '',
      BalAmt: '',
      Remark: '',
    });
    setAllTextDisabled(true);
    setAllButtonDisabled(true);
  }
  const handleClickEdit = () => {
    if (editedRow) {
      setAllTextDisabled(false);
    } else {
      toast.error("Please select a row to edit.");
    }
  };
  const handleDelete = () => {
    if (!editedRow) {
      toast.error("Please select a row to delete.");
      return;
    }
    const currentFormData = formData1 || {};

    const currentTrnRctVchrList = currentFormData.TrnRctVchrList || [];

    const updatedTableData = tableData.map((row) => {
      if (row.PytAdvNo === editedRow.PytAdvNo) {
        if (row.DBFLAG === 'I') {
          toast.success("Record deleted successfully.");
          return null; 
        }

        toast.success("Record marked for deletion.");
        return {
          ...row,
          DBFLAG: 'D'
        };
      }
      return row;
    }).filter(Boolean); 

    const updatedTrnRctVchrList = currentTrnRctVchrList.map((row) => {
      if (row.PytAdvNo === editedRow.PytAdvNo) {
        return {
          ...row,
          DBFLAG: 'D'
        };
      }
      return row;
    });

    // Update states
    setTableData(updatedTableData);
    setFormData({
      ...currentFormData,
      TrnRctVchrList: updatedTrnRctVchrList
    });

    setEditedRow(null);
    setformData({
      Amount: '',
      PytAdvAmount: '',
      RcdAmt: '',
      BalAmt: '',
      Remark: '',
    });

    setAllTextDisabled(true);
    setAllButtonDisabled(true);
  };

  const handlePrev = () => {
    const updatedFormData = {
      ...formData1,
      TrnRctVchrList: tableData.length > 0 ? tableData : formData1?.TrnRctVchrList || []
    };
    setFormData(updatedFormData);

    handleStepClick(0);
  };

  const handleCancelsecond = () => {
    setSelectedRows([]);
    setTotalSelectedBalAmt(0);
    setTotalSelectedRcdAmt(0);
    setOpenDialog(false);
  }
  return (
    <Grid container spacing={2}>
      <ToastContainer />
      <Grid item xs={12} >
        <Paper sx={{ width: "90%", overflow: "hidden", margin: "0px 0px 0px 50px", border: "1px solid lightgray" }}>
          <TableContainer sx={{ maxHeight: 450 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow sx={{ "& > th": { padding: "2px 10px" } }} >
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }} >
                      <Typography variant="subtitle1" fontWeight="bold">
                        {column.label}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {combinedData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center" >
                    </TableCell>
                  </TableRow>
                ) : (
                  combinedData.map((row, index) => (
                    <TableRow
                      hover
                      key={index}
                      sx={{
                        "& > td": { padding: "2px 15px" },
                        cursor: IsButtonSubmit ? "cursor" : "pointer",
                        opacity: IsButtonSubmit ? 0.5 : 1,
                      }}
                      onClick={() => (IsButtonSubmit) ? null : handleRowClick(row)}
                    >
                      {columns.map((column) => (
                        <TableCell key={column.id} align={column.align}>
                          {formatValue(row[column.id], column.id)}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Grid>

      <Grid item xs={12} sx={{ display: "flex", gap: "10px", alignItems: "center", margin: "0px 0px 8px 0px", paddingRight: "100px" }}>
        <Box sx={{ marginLeft: "50px" }}>
          <Button
            variant="contained"
            size="small"
            sx={{ backgroundColor: "#635bff" }}
            onClick={handleAddClick2}
            disabled={AllButtonDisabledOuter && AddDisabled || IsButtonSubmit || !AllTextDisabled}
          >
            <AddIcon />
          </Button>
          <Button variant="contained" size="small"
            sx={{ backgroundColor: "#635bff", margin: "0px 10px" }}
            disabled={AllButtonDisabled || !AllTextDisabled}
            onClick={handleClickEdit}
          >
            <EditIcon />
          </Button>
          <Button variant="contained" size="small"
            sx={{ backgroundColor: "#635bff" }}
            disabled={AllButtonDisabled || !AllTextDisabled}
            onClick={handleDelete}
          >
            <DeleteIcon />
          </Button>
        </Box>

        {/*-------- Total Amount Field -------*/}
        <Box sx={{
          padding: "8px 16px",
          backgroundColor: "#f5f5f5",
          borderRadius: "4px",
          border: "1px solid #ddd",
          display: "flex",
          alignItems: "center"
        }}>
          <Typography variant="subtitle1" fontWeight="bold" sx={{ marginRight: "8px" }}>
            Total RecdAmt:
          </Typography>
          <Typography variant="h6" color="primary">
            {calculateTotalAmount()}
          </Typography>
        </Box>
        {/*   ---------------       */}
      </Grid>

      {/* Dialog to select records */}
      {openDialog && (
        <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="lg" fullWidth>
          <DialogTitle>Select Records</DialogTitle>
          <DialogContent sx={{ overflowY: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingBottom: '10px' }}>

            {/* Filter row */}
            <TableContainer sx={{ mb: 1 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <Checkbox
                        onChange={(e) => {
                          if (e.target.checked) {
                            const allRows = [...fetchedData];
                            setSelectedRows(allRows);
                            // Calculate totals immediately
                            const totalBalAmt = allRows.reduce((total, row) => total + parseFloat(row.BalAmt || 0), 0);
                            const totalRcdAmt = allRows.reduce((total, row) => total + parseFloat(row.Amount || 0), 0);
                            setTotalSelectedBalAmt(totalBalAmt);
                            setTotalSelectedRcdAmt(totalRcdAmt);
                          } else {
                            setSelectedRows([]);
                            setTotalSelectedBalAmt(0);
                            setTotalSelectedRcdAmt(0);
                          }
                        }}
                        checked={selectedRows.length > 0 && selectedRows.length === fetchedData.length}
                        indeterminate={selectedRows.length > 0 && selectedRows.length < fetchedData.length}
                      // onChange={(e) => {
                      //   if (e.target.checked) {
                      //     setSelectedRows([...fetchedData]);
                      //   } else {
                      //     setSelectedRows([]);
                      //   }
                      // }}
                      // checked={selectedRows.length > 0 && selectedRows.length === fetchedData.length}
                      // indeterminate={selectedRows.length > 0 && selectedRows.length < fetchedData.length}
                      />
                      <span style={{ verticalAlign: 'middle' }}>All</span>
                    </TableCell>
                    {columns.map((column) => (
                      <TableCell key={column.id} align="center">
                        <TextField
                          size="small"
                          variant="outlined"
                          fullWidth
                          placeholder={`${column.label}`}
                          onChange={(e) => {
                            const value = e.target.value.toLowerCase();
                            const filtered = fetchedData.filter(row => String(row[column.id]).toLowerCase().includes(value));
                            setFetchedData(filtered);
                            if (!value) {
                              fetchData(ResidentId);
                            }
                          }}
                          sx={{
                            '& .MuiInputBase-root': {
                              height: '30px',
                              padding: '7px 4px',
                            },
                            '& .MuiInputBase-input': {
                              padding: '5px 6px',
                              fontSize: '0.8rem',
                            }
                          }}
                        />
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>

            {/* Data table */}
            <TableContainer sx={{ maxHeight: '35vh', width: '100%' }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Select</TableCell>
                    {columns.map((column) => (
                      <TableCell key={column.id} align="center">
                        <Typography variant="subtitle2" fontWeight="bold">
                          {column.label}
                        </Typography>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {fetchedData.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={columns.length + 1} align="center">No records found</TableCell>
                    </TableRow>
                  ) : (
                    fetchedData.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "& > td": { padding: "2px 10px " },
                          cursor: "pointer",
                        }}
                      >
                        <TableCell align="center">
                          <Checkbox
                            onChange={(e) => handleCheckboxChange(e, row)}
                            checked={selectedRows.some((selectedRow) => selectedRow.PytAdvNo === row.PytAdvNo)}
                          />
                        </TableCell>
                        {columns.map((column) => (
                          <TableCell key={column.id} align="center" sx={{ py: 0.5 }}>
                            {formatValue(row[column.id], column.id)} {/* Adjust data cell formatting */}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Display total BalAmt and RcdAmt */}
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginBottom: '0px' }}>
              {/* UnAllocated Amount */}
              <div style={{
                marginRight: '20px',
                padding: '10px',
                backgroundColor: '#f5f5f5',  // Light gray background
                borderRadius: '5px',
                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                fontWeight: 'bold',
                color: '#d32f2f', // Red color for UnAllocated
                display: 'flex',
                alignItems: 'center'
              }}>
                <strong style={{ marginRight: '10px' }}>UnAllocated Amount:</strong>
                <span>
                  {typeof formData1.RcdAmt === 'number' && !isNaN(formData1.RcdAmt)
                    ? (formData1.RcdAmt - totalSelectedBalAmt).toFixed(2)
                    : !isNaN(parseFloat(formData1.RcdAmt))
                      ? (parseFloat(formData1.RcdAmt) - totalSelectedBalAmt).toFixed(2)
                      : "N/A"
                  }
                </span>
              </div>

              {/* Allocated Amount */}
              <div style={{
                padding: '10px',
                backgroundColor: '#e8f5e9',  // Light green background
                borderRadius: '5px',
                boxShadow: '0 2px 2px rgba(0, 0, 0, 0.1)',
                fontWeight: 'bold',
                color: '#388e3c', // Green color for Allocated
                display: 'flex',
                alignItems: 'center'
              }}>
                <strong style={{ marginRight: '10px' }}>Allocated Amount:</strong>
                <span>
                  {totalSelectedBalAmt.toFixed(2)}
                </span>
              </div>
            </div>


          </DialogContent>
          <DialogActions sx={{ marginTop: 0, paddingTop: '0' }}>
            <Button onClick={handleConfirmSelection} color="primary" disabled={selectedRows.length === 0}>
              Confirm
            </Button>
            <Button onClick={handleCancelsecond} color="secondary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {/* Form and other content */}
      <Grid container spacing={1} sx={{ margin: "auto", paddingLeft: "65px", justifyContent: 'center', alignItems: 'center' }} >
        <Grid container spacing={2} >
          <Grid item lg={8} md={8} xs={12}  >
            <Box display="flex" flexDirection="column" gap={0.5} >

              <Grid container spacing={0.5} >
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label={
                      <span>
                        Recd Amount
                      </span>
                    }
                    name="Amount"
                    variant="filled"
                    className="custom-textfield"
                    disabled={AllTextDisabled}
                    value={formData.Amount}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Doc Amount"
                    name="PytAdvAmount"
                    variant="filled"
                    className="custom-textfield"
                    disabled
                    value={formData.PytAdvAmount}
                    onChange={handleChange}

                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Bal Amount"
                    name="BalAmt"
                    variant="filled"
                    className="custom-textfield"
                    disabled
                    value={formData.BalAmt}
                    onChange={handleChange}
                  />
                </Grid>

              </Grid>
              <Grid container spacing={0.5}>
                <Grid item xs={12} md={12}>
                  <TextField
                    fullWidth
                    label="Remark"
                    name="Remark"
                    variant="filled"
                    className="custom-textfield"
                    disabled={AllTextDisabled}
                    value={formData.Remark}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} className="Receiptform_button" gap="10px">
        <Grid item xs={12} md={3}>
          <Box>
            <Button
              variant="contained"
              size="small"
              sx={{ backgroundColor: "#635bff" }}
              disabled={AllTextDisabled}
              onClick={handleConfirmEdit}
            >
              Confirm
            </Button>
            <Button
              variant="contained"
              size="small"
              sx={{ backgroundColor: "#635bff", margin: "0px 10px" }}
              disabled={AllTextDisabled}
              onClick={handleCancelEdit}
            >
              Cancel
            </Button>
          </Box>
        </Grid>
        {["Prev", "Submit", "Cancel"].map((label, index) => (
          <Button
            key={index}
            sx={{
              background: "linear-gradient(290deg, #4a6572, #6c8a9d)",
              color: '#fff !important',
              width: "50px",
            }}
            variant="contained"
            onClick={label === "Submit" ? handleSubmit :
              label === "Cancel" ? handleCancel
                : label === "Prev" ? handlePrev
                  : null}
            disabled={!AllButtonDisabledOuter}
          >
            {label}
          </Button>
        ))}
      </Grid>

      <ConfirmDialog
        open={confirmDialogVisible}
        onClose={() => {
          setConfirmDialogVisible(false)
          handleStepClick(0)
        }}
        title="Send Email"
        content="Are you sure you want to send Email?"
        onConfirm={emailSender}
      />

    </Grid>
  );
};

export default ReceiptStepper2;